exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-26a5d642]{font-size:.8125rem;color:#222;line-height:1.5;word-wrap:break-word}", ""]);

// exports
